import React from "react";
import { IMAGE_UPLOAD_HINT_TEXT } from "./imageUploadConstants";
import "./image-upload-hint.css";

/**
 * Standard upload guideline + optional validation message for image fields.
 */
const ImageUploadHint = ({ validationMessage, className = "" }) => (
  <div className={`image-upload-hint-wrap ${className}`.trim()}>
    <p className="image-upload-hint">{IMAGE_UPLOAD_HINT_TEXT}</p>
    {validationMessage ? (
      <p className="image-upload-hint image-upload-hint--validation">
        {validationMessage}
      </p>
    ) : null}
  </div>
);

export default ImageUploadHint;
